import BaseModel from "./base/baseModel";

export default class EnsaiosModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    farmacopeiaPadraoId?: number = null;
    soludibilidade = false;
}
